import React, { useState } from 'react';
import { FormFieldCorrespondingAuthor } from '@publishing-engine/domain/types/article';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';
import { EntryPoint } from 'src/utils/types';
import AuthorCard from 'src/pages/Organization/public/Journal/SubmissionUpload/components/AuthorCard';
import { AuthorEditModal } from 'src/pages/Organization/public/Journal/SubmissionUpload/components/AuthorEditModal';

type IProps = {
  formFieldDefinition: FormFieldCorrespondingAuthor;
  value: string;
  previousValue?: string;
  onChange: (value: string) => void;
  entryPoint: EntryPoint;
  isUpdateRequired?: boolean;
};

export const SubmittingAuthorFiled: React.FC<IProps> = ({
  formFieldDefinition,
  value,
  onChange,
  entryPoint,
  isUpdateRequired
}) => {
  const { getFieldState } = useSubmissionFields(entryPoint);
  const authors = getFieldState('Authors')?.value as any;
  const authorDetails = authors.find((author: any) => author.email === value);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    params: { labels }
  } = formFieldDefinition;

  const handleSaveChanges = async (selectedEmail: string) => {
    onChange(selectedEmail);
    setIsEditing(false);
  };

  const isEditable = !!onChange;

  const handleEditClick = (isEditing: boolean) => {
    if (isEditing) {
      setIsModalOpen(true);
    } else {
      setIsEditing(isEditing);
    }
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalConfirm = () => {
    setIsEditing(true);
    setIsModalOpen(false);
  };
  return (
    <>
      <AuthorCard
        title={labels.main}
        subtitle={labels.subtitle}
        isEditing={isEditing}
        showOrcid={false}
        user={{
          ...authorDetails,
          affiliationDetails: {
            organizationName: authorDetails?.affiliation,
            ringgoldId: authorDetails?.ringgoldId
          }
        }}
        options={authors.map((author: any) => ({
          value: author.email,
          label: `${author.firstName} ${author.lastName}`
        }))}
        defaultValue={value}
        onChange={handleSaveChanges}
        onEdit={handleEditClick}
        shouldShowOutline={false}
        disabled={!isEditable || !isUpdateRequired}
      />

      {isModalOpen && (
        <AuthorEditModal
          title="Edit Submitting Author?"
          description="This role manages important submission communications and commitments.
          Ensure consensus among all co-authors before making this change to
          avoid potential conflicts."
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
        />
      )}
    </>
  );
};
